import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class SigtChargementEnCoursService {

  #estVisible = signal(false);
  estVisible = this.#estVisible.asReadonly();

  afficher(visible: boolean): void {
    this.#estVisible.set(visible);
  }
}
